import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Tooltip } from 'primeng/tooltip';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-chip' instead.
 */
@Component({
  selector: 'ag1-tag',
  templateUrl: './ag1-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularSvgIconModule, Tooltip],
})
export class Ag1TagComponent {
  // Path to the icon to be used. Same syntax as specifying 'src' for svg-icon
  @Input() iconPath: string;
  // Text that will appear in more prominent text, next to the icon
  @Input() mainText: string;
  // Text that will appear less prominent, to the right of the main text
  @Input() subText: string;
  // Event emitted when closing the component
  @Output() clickEvent = new EventEmitter<string[]>();

  inputValue: string = '';
  inputState: 'valid' | 'duplicate' | 'invalid' = 'valid';

  remove(): void {
    this.clickEvent.emit();
  }

  get colSpanClass(): string {
    if (this.iconPath && this.mainText && this.subText) {
      return 'col-span-5';
    } else if (this.iconPath && this.mainText && !this.subText) {
      return 'col-span-10';
    } else if (!this.iconPath && this.mainText) {
      return 'col-span-11';
    }
    return ''; // default or fallback class
  }
}
